import {NgModule} from '@angular/core';
import {CampaignComponent} from './campaign.component';
import {CommonInvestSectionsModule} from '../common-invest-sections/common-invest-sections.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {CampaignEnquireFooterModule} from '../../common/campign-enquire-footer/campaign-enquire.module';
import {EnquireNowFormModule} from '../../views/enquire-now-form/enquire-now-form.module';
import {MatButtonModule} from '@angular/material';

@NgModule({
    declarations: [CampaignComponent],
    imports: [CommonSectionsModule, CommonInvestSectionsModule, CampaignEnquireFooterModule, EnquireNowFormModule, MatButtonModule]
})
export class CampaignModule {
}
